import Text from '@cartwhl/ui/base/TextNew';

export default function AssetLibraryMotionSupplementDivider() {
  return (
    <div
      className="col-span-full flex flex-col gap-4 pt-4 pb-2"
      role="separator"
    >
      <div className="border-primary h-px w-full border-t" aria-hidden />
      <Text
        as="h2"
        token="20"
        leading="headline"
        className="text-primary px-2 pt-2"
      >
        From the Motion Library
      </Text>
    </div>
  );
}
